// Removed store import to prevent circular dependency

export const getAmountWithSign = (amount, configData = null) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0';
  }

  // Fallback: Try to resolve configData from persisted Redux store when not provided
  let resolvedConfig = configData;
  if (!resolvedConfig && typeof window !== 'undefined') {
    try {
      const persisted = localStorage.getItem('persist:sixam-mart');
      if (persisted) {
        const root = JSON.parse(persisted);
        if (root?.configData) {
          const slice = JSON.parse(root.configData);
          // Slice shape: { configData, language, countryCode, modules }
          if (slice?.configData) {
            resolvedConfig = slice.configData;
          }
        }
      }
    } catch (e) {
      // silently ignore parse errors
    }
  }

  const digitAfterDecimal = Number.parseInt(
    resolvedConfig?.digit_after_decimal_point ?? 2
  );
  const symbol = resolvedConfig?.currency_symbol ?? '$';
  const direction = resolvedConfig?.currency_symbol_direction ?? 'left';

  let newAmount = ((amount * 100) / 100).toFixed(digitAfterDecimal);

  if (direction === 'left') {
    return `${symbol}${newAmount}`;
  } else if (direction === 'right') {
    return `${newAmount}${symbol}`;
  }
  // Default to left if direction is unknown
  return `${symbol}${newAmount}`;
};

export const getDiscountedAmount = (
  price,
  discount,
  discountType,
  storeDiscount,
  quantity
) => {
  //product wise discount
  let mainPrice = price;
  let q = quantity ? quantity : 1;
  if (Number.parseInt(storeDiscount) === 0) {
    if (discount > 0) {
      if (discountType === "amount") {
        mainPrice = price - discount * q;
      } else if (discountType === "percent") {
        mainPrice = price - (discount / 100) * price;
      }
    }
  } else {
    mainPrice = price - (storeDiscount / 100) * price;
  }
  return mainPrice;
};
export const getSelectedAddOn = (add_ons) => {
  let add_on = "";
  if (add_ons?.length > 0) {
    add_ons?.forEach((item, index) => {
      if (item?.isChecked) {
        add_on += `${index !== 0 ? ", " : ""}${item.name}`;
      }
    });
  }
  return add_on;
};

export const getDiscountAmount = (
  price,
  discount,
  discountType,
  storeDiscount
) => {
  //product wise discount
  let mainPrice = price;
  if (Number.parseInt(storeDiscount) === 0) {
    if (discountType === "amount") {
      mainPrice = discount;
    } else if (discountType === "percent") {
      mainPrice = price * (discount / 100);
    }
  } else {
    if (discountType === "amount") {
      mainPrice = storeDiscount;
    } else if (discountType === "percent") {
      mainPrice = price * (storeDiscount / 100);
    }
  }
  return mainPrice;
};
